import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "./services/auth.service";



@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate
{
    private logical: string;

    constructor(
        private authService: AuthService
    )
    {
        this.susbscribeToCurrentUserInfo();
    }

    private susbscribeToCurrentUserInfo()
    {
        this.authService.currentUserInfo.subscribe(u => this.logical = u.logical);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {

        if (route.url[0].path === "Company" || route.url[0].path === "")
        {
            return true;
        }

        const isUserLoggedIn = this.authService.isLoggedIn();
        if (isUserLoggedIn)
        {
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.authService.logoutRedirect();
        return false;
    }
}
